/**
 * Shared utilities and components for invoice-related functionality
 * Extracts common code to avoid duplication across invoice components
 */

import {
	formatCurrencyToLocale,
	getFormattedDate,
} from "../../../../utils/method";

/**
 * Returns column definitions for historical invoices AgGrid
 * Used in multiple invoice-related components to display historical invoice data
 *
 * @param {Function} t - Translation function from react-i18next
 * @returns {Array} AgGrid column definitions
 */
export const getHistoricalInvoicesColumnDefs = (t) => [
	{
		field: "invoiceNumber",
		headerName: t("invoice.invoice-number"),
		width: 150,
	},
	{
		field: "invoiceDate",
		headerName: t("invoice.invoice-date"),
		width: 120,
		valueFormatter: (params) => getFormattedDate(params.value),
	},
	{
		headerName: t("invoice.billing-period"),
		width: 200,
		valueGetter: (params) => {
			const from = params.data?.billingPeriodFrom;
			const to = params.data?.billingPeriodTo;
			if (!from || !to) return "";
			return `${getFormattedDate(from)} - ${getFormattedDate(to)}`;
		},
	},
	{
		field: "invoiceAmountNet",
		headerName: t("invoice.invoice-net-amount"),
		width: 160,
		type: "numericColumn",
		valueFormatter: (params) => formatCurrencyToLocale(params.value || 0),
	},
	{
		field: "aufmassAmountNet",
		headerName: t("invoice.aufmass-net-amount"),
		width: 160,
		type: "numericColumn",
		valueFormatter: (params) => formatCurrencyToLocale(params.value || 0),
	},
	{
		field: "paymentAmountNet",
		headerName: t("invoice.current-invoice-amount"),
		width: 150,
		type: "numericColumn",
		valueFormatter: (params) => formatCurrencyToLocale(params.value || 0),
	},
	{
		field: "notes",
		headerName: t("common.notes"),
		flex: 1,
		cellClass: 'fst-italic',
	},
];
